'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isolatedScroll = require('isolated-scroll');

var _isolatedScroll2 = _interopRequireDefault(_isolatedScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var unbindHandlersKey = '__unbind_handlers__';

var IsolatedScroll = function (_Component) {
  _inherits(IsolatedScroll, _Component);

  function IsolatedScroll() {
    _classCallCheck(this, IsolatedScroll);

    var _this = _possibleConstructorReturn(this, (IsolatedScroll.__proto__ || Object.getPrototypeOf(IsolatedScroll)).call(this));

    _this.storeComponentReference = _this.storeComponentReference.bind(_this);
    return _this;
  }

  _createClass(IsolatedScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this[unbindHandlersKey] = (0, _isolatedScroll2.default)(this.component);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this[unbindHandlersKey]();
    }
  }, {
    key: 'storeComponentReference',
    value: function storeComponentReference(component) {
      if (component !== null) {
        this.component = component;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        'div',
        _extends({ ref: this.storeComponentReference }, this.props),
        children
      );
    }
  }]);

  return IsolatedScroll;
}(_react.Component);

IsolatedScroll.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};
exports.default = IsolatedScroll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-isolated-scroll/lib/index.js
// module id = 576
// module chunks = 0